module.exports = __webpack_public_path__ + "img/lbsq.2deb94fa.png";